import { createSlice } from "@reduxjs/toolkit";
import { getAllActiveTickets } from "@/services/ticket.services";

interface TicketState {
  loading: boolean;
  error: string;
  TicketList: unknown[];
  TicketDetails: Record<string, unknown>;
}

const initialState: TicketState = {
  loading: false,
  error: "",
  TicketList: [],
  TicketDetails: {},
};

const ticketSlice = createSlice({
  name: "ticket",
  initialState,
  reducers: {
    clearTicketDetails: (state) => {
      state.TicketDetails = initialState.TicketDetails;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActiveTickets.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveTickets.fulfilled, (state, action) => {
      state.loading = false;
      state.TicketList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveTickets.rejected, (state, action) => {
      state.loading = false;
      state.TicketList = [];
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export default ticketSlice.reducer;
export const { clearTicketDetails } = ticketSlice.actions;
